/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import moment from 'moment';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class AssessmentDataRoute extends Route {
  // Services
  @service
  store;

  model() {
    let currentFrom = moment().subtract(1, 'year').format('YYYY-MM-DD');
    let currentTo = moment().format('YYYY-MM-DD');
    return hash({
      assessments: this.store.findAll('assessments/assessment'),
      jurisdictionalIdField: this.store.queryRecord('people-schema/field', {
        jurisdictionalId: true,
      }),
      learners: this.store
        .query('people/enrolment', {
          include: 'people',
          currentFrom,
          currentTo,
        })
        .then((enrolments) => {
          return enrolments.map((enrolment) => {
            return this.store.peekRecord('person', enrolment.personId);
          });
        }),
    });
  }
}
